import { Headline, Icon } from '@oneaudi/unified-web-components';
import type { FC, MouseEvent } from 'react';
import React from 'react';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_400 } from '@oneaudi/unified-web-common';

export interface FilterCategoryButtonProps {
  readonly onClickHandler: (event: MouseEvent) => void;
  readonly text: string;
  readonly isActive?: boolean;
}

export const FilterCategoryButton: FC<FilterCategoryButtonProps> = React.forwardRef<
  HTMLButtonElement,
  FilterCategoryButtonProps
>(({ onClickHandler, text, isActive }, ref) => (
  <StyledButton
    type="button"
    onClick={(event) => onClickHandler(event)}
    isActive={isActive}
    ref={ref}
    data-isactive={isActive}
    data-testid={`filterCategoryBtn-${text?.split(' ')[0]}`}
    className="filterCategoryBtn"
  >
    <Headline
      variant={{
        order: '4',
        weight: 'normal',
        type: 'headline',
      }}
      tag="h3"
    >
      {text}
    </Headline>

    <Icon name={isActive ? 'forward-active' : 'forward'} size="s" />
  </StyledButton>
));

const StyledButton = styled.button<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-relative-md) 0;
  border: none;
  background-color: transparent;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-align: left;
  cursor: pointer;
  appearance: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    padding: 0;

    & + & {
      margin-top: ${SYS_SPACE_FIXED_400};
    }
  }

  &:hover {
    p {
      color: ${({ theme }) => theme.colors.defaultTextColor};
    }

    svg {
      color: ${({ theme }) => theme.colors.defaultTextColor};
    }
  }

  p {
    color: ${({ theme, isActive }) =>
      isActive ? theme.colors.defaultTextColor : theme.colors.filterCategoryUnselectedTextColor};
  }

  svg {
    color: ${({ theme }) => theme.colors.filterCategoryUnselectedTextColor};
  }
`;
